/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

interface AudioInputModelLike {
  provider_name?: string;
  audio_input_supported?: boolean | null;
}

export function isAudioInputSupported(model?: AudioInputModelLike | null): boolean {
  return model?.audio_input_supported === true;
}

export function getAudioInputDisabledReason(model?: AudioInputModelLike | null): string {
  if (!model) {
    return 'Voice input is unavailable until model details finish loading.';
  }
  const providerName = model.provider_name || 'this model';
  return `Voice input is not available for ${providerName} in this chat yet. Switch to an audio-capable model or send a transcript.`;
}